import { render, staticRenderFns } from "./MediaRadioButton.vue?vue&type=template&id=36639d27&scoped=true"
import script from "./MediaRadioButton.vue?vue&type=script&lang=js"
export * from "./MediaRadioButton.vue?vue&type=script&lang=js"
import style0 from "./MediaRadioButton.vue?vue&type=style&index=0&id=36639d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36639d27",
  null
  
)

export default component.exports